(() => {
  let attempts = 0;
  const boot = () => {
    const api = window.RoconectEasybox;
    if (!api || !window.__rcQuickcartConfig) {
      if (++attempts < 80) setTimeout(boot, 250);
      return;
    }
    if (window.__rcQuickcartConfig.requireChoice !== true) return;
    const originalFetch = window.fetch.bind(window);
    const root = window.Shopify?.routes?.root || '/';
    const keys = ['Selected Delivery Method', 'Locker Courier', 'Locker ID', 'Locker Address', 'Locker Street', 'Locker City', 'Locker County', 'Locker Postal Code', 'Sameday Locker ID', 'Sameday Locker Address', 'Sameday Locker Raw'];
    let queue = Promise.resolve();
    let blocked = false;
    const reset = async (cart) => {
      if (cart.item_count !== 0) return;
      blocked = true;
      api.closeModal();
      try { localStorage.removeItem('rc-home-chosen-cart'); } catch (_) {}
      api.revertToHomeOnAllBlocks();
      if (keys.some(key => cart.attributes?.[key])) {
        const response = await originalFetch(root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: Object.fromEntries(keys.map(key => [key, ''])) })
        });
        if (!response.ok) throw new Error('RoConnect delivery reset failed');
        const updated = await response.json();
        if (keys.some(key => updated.attributes?.[key])) throw new Error('RoConnect delivery attributes were not cleared');
      }
      api.revertToHomeOnAllBlocks();
      blocked = false;
    };
    const report = error => { console.error('[Zentamine delivery reset]', error); };
    queue = originalFetch(root + 'cart.js').then(response => {
      if (!response.ok) throw new Error('Cart read failed');
      return response.json();
    }).then(reset).catch(report);
    window.fetch = function(input, options) {
      const address = typeof input === 'string' ? input : input?.url;
      let url;
      try { url = new URL(address, location.href); } catch (_) { return originalFetch(input, options); }
      if (url.origin !== location.origin || !/\/cart\/(add|change|update|clear)(\.js|\.json)?$/.test(url.pathname)) return originalFetch(input, options);
      const task = queue.then(async () => {
        const response = await originalFetch(input, options);
        if (response.ok) {
          try { await reset(await response.clone().json()); } catch (error) { report(error); }
        }
        return response;
      });
      queue = task.then(() => {}, () => {});
      return task;
    };
    document.addEventListener('eurus:cart:items-changed', () => {
      const check = queue.then(async () => {
        const response = await originalFetch(root + 'cart.js', { cache: 'no-store' });
        if (!response.ok) throw new Error('Cart read failed');
        await reset(await response.json());
      });
      queue = check.catch(report);
    });
    const guard = event => {
      if (!blocked) return;
      const target = event.type === 'submit' ? event.submitter : event.target;
      if (target?.closest('#checkout-submit, [name="checkout"], a[href$="/checkout"], [data-rc-option]')) {
        event.preventDefault(); event.stopImmediatePropagation();
      }
    };
    window.addEventListener('click', guard, true);
    window.addEventListener('submit', guard, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
